export default "__VITE_ASSET__DxVSv4B6__"